<template>
  <div class="stats-sidebar">
    <div class="stat-card mb-4">
      <div class="stat-icon-container books">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="stat-icon">
          <path d="M6 2C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V4C20 2.9 19.1 2 18 2H6ZM6 4H18V20H6V4ZM8 6V8H16V6H8ZM8 10V12H16V10H8Z" fill="currentColor"/>
        </svg>
      </div>
      <div class="stat-content">
        <h2 class="stat-value">{{ (analytics.totalBooks || 0).toLocaleString() }}</h2>
        <p class="stat-label">TOTAL BOOKS</p>
      </div>
    </div>
    
    <div class="stat-card mb-4">
      <div class="stat-icon-container authors">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="stat-icon">
          <path d="M12 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8zM6 8a6 6 0 1 1 12 0A6 6 0 0 1 6 8zm2 10a3 3 0 0 0-3 3 1 1 0 1 1-2 0 5 5 0 0 1 5-5h8a5 5 0 0 1 5 5 1 1 0 1 1-2 0 3 3 0 0 0-3-3H8z" fill="currentColor"/>
        </svg>
      </div>
      <div class="stat-content">
        <h2 class="stat-value">{{ (analytics.totalAuthors || 0).toLocaleString() }}</h2>
        <p class="stat-label">AUTHORS</p>
      </div>
    </div>
    
    <div class="stat-card mb-4">
      <div class="stat-icon-container sold">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="stat-icon">
          <path d="M4 6H22V4H4C2.9 4 2 4.9 2 6V17C2 18.1 2.9 19 4 19H5V17H4V6ZM7 19H9V17H7V19ZM11 19H13V17H11V19ZM15 19H17V17H15V19ZM22 8H19V15.5C19 16.33 18.33 17 17.5 17C16.67 17 16 16.33 16 15.5C16 14.67 16.67 14 17.5 14C17.86 14 18.19 14.15 18.43 14.41V8H22Z" fill="currentColor"/>
        </svg>
      </div>
      <div class="stat-content">
        <h2 class="stat-value">{{ (analytics.totalBooksSold || 0).toLocaleString() }}</h2>
        <p class="stat-label">BOOKS SOLD</p>
      </div>
    </div>
    
    <div class="stat-card">
      <div class="stat-icon-container happy">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="stat-icon">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-4-8c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm8 0c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm-4 5.5c2.07 0 3.89-1.09 4.92-2.72-.32-.18-.69-.28-1.08-.28H8.16c-.39 0-.76.1-1.08.28 1.03 1.63 2.85 2.72 4.92 2.72z" fill="currentColor"/>
        </svg>
      </div>
      <div class="stat-content">
        <h2 class="stat-value">100%</h2>
        <p class="stat-label">HAPPY<br>CUSTOMER</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SidebarStats',
  props: {
    analytics: {
      type: Object,
      default: () => {},
    },
  }
}
</script>

<style lang="scss" scoped>
.stats-sidebar {
  padding: 15px;
  max-width: 400px;
  margin: 0 auto;
}

.stat-card {
  display: flex;
  align-items: center;
  background-color: #fff;
  border: 1px solid #e7e7e7;
  border-radius: 16px;
  padding: 30px;
  overflow: hidden;
}

.stat-icon-container {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  flex-shrink: 0;
  
  &.books {
    background-color: #f0efff;
    color: #6c5ce7;
  }
  
  &.authors {
    background-color: #e6f7ff;
    color: #56c4d3;
  }
  
  &.sold {
    background-color: #e8f5e9;
    color: #78c48a;
  }
  
  &.happy {
    background-color: #fff5ec;
    color: #f39c58;
  }
}

.stat-icon {
  width: 34px;
  height: 34px;
}

.stat-content {
  flex-grow: 1;
}

.stat-value {
  font-size: 30px;
  font-weight: bold;
  margin: 0;
  line-height: 1.2;
  color: #000;
}

.stat-label {
  font-size: 14px;
  color: #999;
  margin: 0;
  letter-spacing: 1px;
  font-weight: 500;
  line-height: 1.4;
}
</style>
